<ngx-spinner size="medium" class="wrp-spinner" type="ball-spin"></ngx-spinner>
<app-header *ngIf="headerVisible"></app-header>
<router-outlet></router-outlet>
